import { createTheme, } from '@mui/material';

// Create a custom theme with the desired primary color
export default createTheme({
    palette: {
        primary: {
            main: '#8c7c0c',
            contrastText:'#F5F1DA'
        },
    },
    typography: {
        fontFamily: [
            '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto',
            '"Helvetica Neue"', 'Arial', 'sans-serif'
        ].join(','),
    },
    components: {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: 13,
                    borderColor: '#eef0f3',
                },
                head: {
                    fontWeight: 700,
                    fontSize: 12.5,
                    color: '#111827',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                sizeSmall: {
                    fontSize: 11,
                    fontWeight: 600,
                },
            },
        },
    },
});
